/**
 * 创作分发—通知公告
 * Bai.Zhiming
 * 2019-06-27
 *
 */
angular
    .module('iwoNoticeModule', [
        'iwoNoticeRouter', // iwo通知公告路由
        'iwoNoticeCreateModule', // iwo通知公告新建页
        'iwoNoticeDetailModule', // iwo通知公告详情页
        'iwoNoticeServiceModule', // iwo公告服务
        'timeShowFormatModule', // 时间格式转换
    ])
    .controller('iwoNoticeCtrl', [
        '$scope',
        'trsHttpService',
        '$q',
        'modalDialog',
        '$state',
        'trsspliceString',
        '$sessionStorage',
        'iwoNoticeService',
        'messageCenterService',
        function($scope, trsHttpService, $q, modalDialog, $state, trsspliceString, $sessionStorage, iwoNoticeService, messageCenterService) {
            initStatus();
            initData();

            /**
             * [initStatus 初始化状态]
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    hasReadArr: '',
                };
                $scope.data = {
                    items: [], // 公告列表
                    selectedArray: [], // 已选
                    keyWords: '', // 关键字
                    fromdate: '', // 发布日期筛选-开始日期
                    untildate: '', // 发布日期筛选-结束日期
                };

                /**
                 * [page description:分页信息]
                 */
                $scope.hotLists = {
                    page: {
                        pn: 1, // 当前页
                        PAGESIZE: 20, // globleParamsSet.getPageSize(),
                        ITEMCOUNT: 0, // 总共多少数据
                        startpage: 0,
                    },
                    status: {
                        jumpToPageNum: 1,
                        startpage: 0,
                    },
                };

                $scope.rights = {};
            }

            /**
             * [getData 获取列表数据]
             *
             * @param   {[type]}  page  [page description]
             *
             * @return  {[type]}        [return description]
             */
            function getData(page) {
                $scope.data.items = [];
                let defer = $q.defer();
                let params = {
                    pageNumber: $scope.hotLists.page.pn,
                    pageSize: $scope.hotLists.page.PAGESIZE,
                };
                if ($scope.data.keyWords) {
                    params.keyWords = $scope.data.keyWords;
                }
                if ($scope.data.fromdate) {
                    params.startTime = $scope.data.fromdate;
                }
                if ($scope.data.untildate) {
                    params.endTime = $scope.data.untildate;
                }
                $scope.loadingPromise = iwoNoticeService.getReciveNoticeList(params).then((data) => {
                    if (data.issuccess == 'false') {
                        modalDialog.alertType('', data.msg, 'error', false);
                        defer.reject();
                    } else {
                        $scope.data.items = data.data.content;
                        $scope.hotLists.page.ITEMCOUNT = data.data.totalElements;
                        $scope.hotLists.page.pn = ++data.data.number;
                        $scope.hotLists.page.PAGECOUNT = data.data.totalPages;
                        hasRead();
                        defer.resolve();
                    }
                });
                return defer.promise;
            }

            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                getRights();
                getData();
            }

            /**
             * [getRights 获取权限]
             *
             * @return  {[type]}  [return description]
             */
            function getRights() {
                iwoNoticeService.getNoticeRights().then((data) => {
                    if (data && data.length) {
                        data.forEach((item) => {
                            $scope.rights[item.OPERNAME] = true;
                        });
                    }
                });
            }

            /**
             * [requestData 改变条件，请求数据]
             *
             * @param   {[type]}  ev  [ev description]
             *
             * @return  {[type]}      [return description]
             */
            $scope.requestData = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    getData();
                }
            };

            /**
             * [pageChanged description]分页请求
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.hotLists.status.jumpToPageNum = $scope.hotLists.page.pn;
                $scope.hotLists.page.startpage = $scope.hotLists.page.pn - 1;
                getData();
                $scope.data.selectedArray = [];
            };

            /**
             * [jumpToPage description] 跳转分页
             * @return {[type]} [description]
             */
            $scope.jumpToPage = function() {
                if ($scope.hotLists.status.jumpToPageNum > $scope.hotLists.page.PAGECOUNT) {
                    $scope.hotLists.status.jumpToPageNum = $scope.hotLists.page.PAGECOUNT;
                }
                if ($scope.hotLists.status.jumpToPageNum === '0' || isNaN(Number($scope.hotLists.status.jumpToPageNum))) {
                    modalDialog.alertType('请输入合法的页码', '', 'warning', false);
                    return;
                }
                $scope.hotLists.page.startpage = $scope.hotLists.status.jumpToPageNum - 1;
                $scope.hotLists.page.pn = $scope.hotLists.status.jumpToPageNum;
                getData();
                $scope.data.selectedArray = [];
            };

            /**
             * [checkSelect 判断是否选中]
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.checkSelect = function(item) {
                return $scope.data.selectedArray.some((_item) => _item.noticeid == item.noticeid);
            };

            /**
             * [selectCheckAdd description] 选中/取消选中元素
             * @param  {[type]} item [description] 元素
             * @return {[type]}      [description]
             */
            $scope.selectCheckAdd = function(item) {
                if ($scope.checkSelect(item)) {
                    $scope.data.selectedArray = $scope.data.selectedArray.filter((_item) => _item.noticeid != item.noticeid);
                } else {
                    $scope.data.selectedArray.push(item);
                }
            };

            /**
             * [selectAll description] 全选
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                if ($scope.data.selectedArray.length == $scope.data.items.length && $scope.data.items.length > 0) {
                    $scope.data.selectedArray = [];
                } else {
                    $scope.data.selectedArray = [].concat($scope.data.items);
                }
            };

            /**
             * [comparisonArr description]
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
            function comparisonArr(data) {
                $scope.data.items.forEach((item) => {
                    for (var key in data) {
                        if (key == item.noticeid) {
                            item.readStatus = String(data[key].read) + '/' + String(data[key].total);
                        }
                    }
                });
            }

            /**
             * [noticeManage 跳转至公告管理]
             *
             * @return  {[type]}  [return description]
             */
            $scope.noticeManage = function() {
                $state.go('front.editctr.iWo.notice.manage', {});
            };

            /**
             * [hasRead 判断是否已读]
             *
             * @return  {[type]}  [return description]
             */
            function hasRead() {
                var noticeids = trsspliceString.spliceString($scope.data.items, 'noticeid', ',');
                messageCenterService.hasRead(noticeids).then((data) => {
                    $scope.status.hasReadArr = data.data;
                    $scope.data.items.forEach((notices, i) => {
                        for (var hasReadArr in $scope.status.hasReadArr) {
                            if (notices.noticeid == hasReadArr) {
                                notices.isRead = $scope.status.hasReadArr[hasReadArr];
                            }
                        }
                    });
                });
            }

            /**
             * [markAsRead 标记为已读]
             *
             * @param   {[type]}  type  [type 类型（0:已选数据标记为已读 1:全部标记为已读)]
             *
             * @return  {[type]}        [return description]
             */
            $scope.markAsRead = function(type) {
                var opertype = type;
                var noticeids = trsspliceString.spliceString($scope.data.selectedArray, 'noticeid', ',');
                if (type == 0) {
                    messageCenterService.readNotices(noticeids, !!opertype).then((data) => {
                        getData();
                        modalDialog.alertType('设置成功', '', 'success', false);
                    });
                } else {
                    noticeids = trsspliceString.spliceString($scope.data.noticesList, 'noticeid', ',');
                    messageCenterService.readNotices(noticeids, !!opertype).then((data) => {
                        getData();
                        modalDialog.alertType('设置成功', '', 'success', false);
                    });
                }
                $scope.data.selectedArray = [];
                iwoNoticeService.getUnReadNoticeCount();
            };

            /**
             * [openPreview description]打开预览页
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.openPreview = function(item) {
                $scope.loadingPromise = iwoNoticeService.openPreview(item, false).then(
                    () => {
                        getData();
                        iwoNoticeService.getUnReadNoticeCount();
                    },
                    () => {
                        getData();
                        iwoNoticeService.getUnReadNoticeCount();
                    }
                );
            };
        },
    ]);
